import React, {Component} from "react";
import {connect} from "react-redux";
import {Box, Button, Grid, Theme, Typography} from '@material-ui/core/';
import {withStyles} from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import * as actions from "../../../../store/actions";
import {Auth, Hub} from "aws-amplify";
import ValidateForm from "../../../../helper/validations";
import CircularProgress from '@material-ui/core/CircularProgress';
import {checkUserAuth} from "./checkUserAuth";
import {CognitoHostedUIIdentityProvider} from "@aws-amplify/auth";
import {Styles} from "@material-ui/core/styles/withStyles";
import Backdrop from "@material-ui/core/Backdrop/Backdrop";
import Alert from '@material-ui/lab/Alert';
import ReactHtmlParser, {processNodes} from "react-html-parser";
import {Helmet} from "react-helmet";
import PrivacyModal from './privacypopup';
import clsx from 'clsx';
import Config from "../../../../config/config";


const useStyles: Styles<Theme, any, any> = () =>({
  root: {
    backgroundColor: '#d7d7d7!important',
    width: '100vw',
    height: '100vh'
  },
  actionButtons: {
    minWidth: '460px',
    marginBottom: '20px',
    '@media (max-width: 760px)': {
      minWidth: '250px'
    },
    color: '#3177d8',
    border: '1px solid rgba(49, 119, 216, 0.5)',
    '&:hover': {
			border: '1px solid #3177d8',
      backgroundColor: 'rgba(49, 119, 216, 0.04)'
		},
    padding: '20px'
  },
  textCenter: {
    textAlign: 'center',
    color: '#393c41'
  },
  textRight: {
    textAlign: 'right',
  },
  registerLogo:{
    width:"20vw",
    '@media (max-width: 768px)': {
      width:"60vw"
    },
  },
  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#d7d7d7',
    width: '100vw',
    backgroundImage: 'url(/assets/images/known/lady_header.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#fdca42'
  },
  signupText: {
    color: '#393c41'
  },
  error: {},
  passwordInput: {
    width: '100%',
    "& .MuiInputAdornment-positionEnd": {
      margin: "0!important",
    }
  },
  bottomleft:{
    textAlign:"left",
    '@media (max-width: 960px)': {
      textAlign:"center"
    },
  },
  bottomimageleft:{
    width: "354px",
    height: "161px",
    marginTop:"140px",
    marginLeft:"30px",
    '@media (max-width: 767px)': {
      margin:"0 auto",
      maxWidth: "354px",
      width:"90%"
    },
  },
  bottomright:{
    textAlign:"right",
    '@media (max-width: 960px)': {
      textAlign:"center",
    },
  },
  bottomimageright:{
    width: "374px",
    // height: "260px",
    marginRight:"30px",
    '@media (min-width: 768px) and (max-width:992px)': {
      marginRight:"0",
    },
    '@media (max-width: 767px)': {
      margin:"0 auto",
      width:"90%",
      maxWidth: "374px",
    },
  }
});

interface IProps {
  authUser: any,
  history: any,
  notification: any,
  apolloClient: any,
  loginUser: (client: any, requestData: any, history: any) => void,
  ResendLink: (client: any, request: any) => void,
  classes: any;
  location: any;
}

interface IState {
  email: string,
  password: string,
  googleLoading: boolean,
  appleLoading: boolean,
  is_rememberMe: string,
  accountVeryfied: any,
  resendLinkLoading: boolean,
  user: any,
  customState: any,
  errorMsg: string;
  recaptchaError: any;
  [key: string]: any,
  auto_login: boolean,
}

class Login extends Component<IProps, IState> {
  
  recaptcha: any;
  constructor(props: IProps) {

    super(props);
    this.state = {
      email: "",
      password: "",
      errorMsg: "",
      googleLoading: false,
      appleLoading: false,
      is_rememberMe: 'false',
      accountVeryfied: false,
      resendLinkLoading: false,
      user: {},
      customState: {},
      recaptchaError: false,
      privacyData: props.authUser.privacyData,
      isRscUrl:false,
      rscText:"",
      auto_login: false
      
    };
  }

  /* Load init data */
  componentDidMount() {

    localStorage.removeItem("rscString");
    Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          this.setState({ user: data });
          break;
        case "signOut":
          this.setState({ user: null });
          break;
        case "customOAuthState":
          this.setState({ customState: data });
          if(data && typeof(data) === "string" && data !==""){
            this.setState({ rscText: data });
          }
          break;
        default:
          break;
      }
    });
    // check user authentication
    if(!localStorage.getItem("user_data")){
      checkUserAuth(this);
    }
    const _this = this
    window.addEventListener('beforeunload', function() {
      if( _this.props.authUser.privacyData ) {
        _this.props.authUser.privacyData = null
      } 
      if( _this.props.authUser.loginDetails ) {
        _this.props.authUser.loginDetails = null
      }
    });
    const queryStringRsc = new URLSearchParams(_this.props.history.location.search).get("rsc")
    if(queryStringRsc){
      this.setState({
        isRscUrl:true,
        rscText:queryStringRsc,
        rscRoute:"/user/register?rsc="+queryStringRsc,
      })
    }
    if (localStorage.getItem("auto_login")) {
      this.setState({
        auto_login: true
      }, () => localStorage.removeItem("auto_login"))
    }
  }

  // when receive updates from reducers
  UNSAFE_componentWillReceiveProps(props: any) {
    if (props.location.state && props.location.state.email && props.location.state.password) {
      this.setState({
        email: props.location.state.email,
        password: props.location.state.password
      }, () => this.onUserLogin());
      props.location.state.email = null
      props.location.state.password = null
      window.history.replaceState("", "", "/user/login");
      return;
    }
    if (props.authUser.privacyData) {
      this.setState({
        privacyData: props.authUser.privacyData
      }, () => setTimeout(() => {
        this.setState({ auto_login: false })
      }, 2000))
    }
    if (props.authUser.loginDetails) {
      this.setState({
        email:props.authUser.loginDetails.email,
        password:props.authUser.loginDetails.password
      })
      props.authUser.loginDetails = null
    }
    if (props.notification) {
      if (props.notification.message && !props.notification.success) {
        this.setState({
          errorMsg: props.notification.message,
          auto_login: false
        });
      }
      this.setState({
        googleLoading: false,
        appleLoading: false
      });
      if (this.state.resendLinkLoading) {
        this.setState({
          accountVeryfied: false,
          resendLinkLoading: false,
          errorMsg: ""
        })
      }
    }
    if (this.props.authUser.accountNotVeryfied) {
      this.setState({ accountVeryfied: props.authUser.accountNotVeryfied });
      this.props.authUser.accountNotVeryfied = false
    } else {
      this.props.authUser.accountNotVeryfied = false
      this.setState({ accountVeryfied: false });
    }
    // don't show the alert when back to this page.
    if (!this.state.email && localStorage.getItem('sso_login') === "false") {
      this.setState({ errorMsg: "" })
    }
  }

  // when user try to login
  onUserLogin = () => {
    const requestData = {
      email: this.state.email,
      password: this.state.password
    };
    const { is_rememberMe } = this.state;
    const validateError = ValidateForm.validateLoginForm(requestData);
    this.setState({ errorMsg: "" });
    localStorage.setItem('sso_login', String(false));
    if (!Object.keys(validateError).length) {
      if (is_rememberMe) {
        localStorage.setItem('is_rememberMe', this.state.is_rememberMe);
      } else {
        localStorage.removeItem('is_rememberMe');
      }
      this.props.loginUser(this.props.apolloClient.client, requestData, this.props.history);
    } else {

    }
  };

  // login in with google
  googleLogin = async () => {
    localStorage.setItem('sso_login', String(true));
    this.setState({ googleLoading: true });
    await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google,customState:this.state.rscText });
  };

  // login in with apple
  appleLogin = async () => {
    localStorage.setItem('sso_login', String(true));
    this.setState({ appleLoading: true });
    await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Apple,customState:this.state.rscText });
  };

  // sign up with email address
  openLoginEmail = async () => {
    this.props.history.push('/user/login/email-password');
  };

  // resend link mail
  resendLink = () => {
    if (this.state.accountVeryfied && this.state.accountVeryfied.username) {
      const request = {
        email: this.state.accountVeryfied.username,
        brand: Config.DEFAULT_SUBBRAND,
      };
      this.setState({ resendLinkLoading: true })
      this.props.ResendLink(this.props.apolloClient.client, request)
    }
  };

  transform = (node: any, index: any) => {
    const { resendLinkLoading } = this.state;
    if (node.type === "tag" && node.name === "span") {
      return (
        <span style={{ cursor: "pointer" }} onClick={() => this.resendLink()} key={index}>
          {resendLinkLoading && <CircularProgress color="inherit" size={10}/>}
          { !resendLinkLoading && processNodes(node.children, this.transform) }
        </span>
      );
    }
  };

  render() {
    const { classes, authUser } = this.props;

    const {
      googleLoading,
      appleLoading,
      errorMsg
    } = this.state;

    const options = {
      decodeEntities: true,
      transform: this.transform
    };

    return (
      <React.Fragment>
        <Helmet title="Login"/>
        <div className={classes.layout}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Box className="">
                {!this.state.auto_login &&
                <>
                  <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)} style={{marginBottom: 30}}>Create Surprisingly Awesome Experiences.</Typography>
                  <div className="login-form">
                    <Button type="button"
                            color="default"
                            variant="outlined"
                            size="large"
                            className={classes.actionButtons}
                            startIcon={ !googleLoading && <img src="/assets/images/google.svg" alt="{img}" className="social-icon"/> }
                            disabled={ googleLoading }
                            onClick={() => this.googleLogin()}>
                      {googleLoading && <CircularProgress color="inherit" size={20}/>}
                      { !googleLoading && <p>Continue with Google</p> }
                    </Button>
                    <Button type="button"
                            color="secondary"
                            variant="outlined"
                            size="large"
                            startIcon={ !appleLoading && <img src="/assets/images/apple.svg" alt="{img}" className="social-icon"/> }
                            className={classes.actionButtons}
                            disabled={ appleLoading }
                            onClick={() => this.appleLogin()}>
                      {appleLoading && <CircularProgress color="inherit" size={20}/>}
                      { !appleLoading && <p>Continue with Apple</p> }
                    </Button>
                    <Button
                      type="button"
                      color="secondary"
                      variant="outlined"
                      size="large"
                      className={classes.actionButtons}
                      startIcon={ !appleLoading && <img src="/assets/images/mail.svg" alt="{img}" className="social-icon"/> }
                      onClick={this.openLoginEmail}
                    >
                      Sign in with email
                    </Button>
                    {!this.state.isRscUrl &&
                    <Typography variant="subtitle1" className={classes.signupText} >Don’t have an account yet? <Link to="/user/begin/free" target="" className={classes.signupText} style={{textDecoration: 'underline'}}>Sign up</Link></Typography>
                    }
                    {this.state.isRscUrl &&
                    <p className="text-signin" style={{ marginTop:22, color: '#393c41' }}>Don’t have an account yet? <Link to={this.state.rscRoute} target="" className={classes.signupText} style={{textDecoration: 'underline'}} >Sign up</Link></p>
                    }
                    { errorMsg && <Alert icon={false} style={{width:"100%"}} className="error-alert" severity="error">{ ReactHtmlParser(errorMsg, options) }</Alert> }
                  </div>
                </>
                }
              </Box>
            </Grid>
          </Grid>
          <div className="loader">
            <Backdrop open={authUser.screen_loading || this.state.auto_login} >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
          <PrivacyModal docData={this.state.privacyData} email={this.state.email} password={this.state.password} sessionData={this.state.sessionData?this.state.sessionData:{}}/>
        </div>
      </React.Fragment>
    );
  }
}

// load reducers
const mapStateToProps = (state: any) => ({
  authUser: state.authUser,
  apolloClient: state.apolloClient,
  notification: state.notification
});

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    loginUser: (client: any, request: any, history: any) => { dispatch(actions.loginUser(client, request, history)); },
    ResendLink: (client: any, request: any) => { dispatch(actions.ResendLink(client, request)); },
    onAuthCheckState: (history: any) => { dispatch(actions.onAuthCheckState(history)); },
    logoutUserSuccess: (user: any) => { dispatch(actions.logoutUserSuccess(user)); },
    onLogout: () => { dispatch(actions.onLogout()); },
    acceptDocument: (client: any,request: any) => { dispatch(actions.acceptDocument(client, request)); },
  };
};

const LoginComponent = withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Login));

export {
  LoginComponent
}